import * as React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { Checkbox } from "../../../../components/ui/checkbox";
import { Label } from "../../../../components/ui/label";

export function APD_TGL_NTL() {
  const { control } = useFormContext();
  const step8Carrier = useWatch({ control, name: "step8.carrier" });

  const onlyHasAccelerant = step8Carrier?.length === 1 && step8Carrier[0] === "Accelerant";
  return (
    <>
      <div className="space-y-3 my-1 rounded-lg border p-4">
        <div className="flex items-center gap-3 space">
          <Controller
            control={control}
            name="step8.automobile_physical_damage"
            render={({ field }) => (
              <Checkbox id="cov-apd" checked={!!field.value} onCheckedChange={field.onChange} />
            )}
          />
          <Label htmlFor="cov-apd" className="cursor-pointer">Automobile Physical Damage (APD)</Label>
        </div>
      </div>
      <div className="space-y-3 my-1 rounded-lg border p-4">
        <div className="flex items-center gap-3">
          <Controller
            control={control}
            name="step8.truckers_general_liability"
            render={({ field }) => (
              <Checkbox id="cov-tgl" checked={!!field.value} onCheckedChange={field.onChange} />
            )}
          />
          <Label htmlFor="cov-tgl" className="cursor-pointer">Truckers General Liability (TGL)</Label>
        </div>
      </div>

      {
        !onlyHasAccelerant && (
          <div className="space-y-3 my-1 rounded-lg border p-4">
            <div className="flex items-center gap-3">
              <Controller
                control={control}
                name="step8.non_trucking_liability"
                render={({ field }) => (
                  <Checkbox id="cov-ntl" checked={!!field.value} onCheckedChange={field.onChange} />
                )}
              />
              <Label htmlFor="cov-ntl" className="cursor-pointer">Non-Trucking Liability (NTL)</Label>
            </div>
          </div>
        )
      }
    </>
  );
}
